import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import {
    CircularProgress, FormControl,
    Select,
    MenuItem,
    FormHelperText,
    InputLabel,
    Radio
} from '@material-ui/core';
import { withTheme } from '@material-ui/core/styles';
import { validateSignUpData } from '../../utils/validators/validateForm';
import { NotificationManager } from 'react-notifications';
import { ROLE_CUSTOMER, SERVER_URL, countries } from '../../utils/config/constants';
import { Redirect, withRouter } from 'react-router-dom';
import * as actions from '../../actions';
import { compose } from 'redux';
import { connect } from 'react-redux';
import axios from 'axios';

import CustomerVerification from './CustomerVerification';
import { FormattedMessage, injectIntl } from 'react-intl';
import Cookies from 'universal-cookie';
import { cookies } from '../../utils/getToken';
class CustomerSignup extends Component {
    constructor(props) {
        super(props);
        console.log("wwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwww", props)
        this.state = {
            loaderButton: false,
            email: '',
            password: '',
            value: 0,
            nameError: '',
            name: '',
            isVerificationOpen: false,
            closeVerification: false,
            playerId: '',
            refferError: "",
            reffer: "",
            hideGetOtp: false,
            hideLogin: true,
            countryCode: "",
            phone: '',
            countryCode: '1',
            hideExtraField: true,
            showVerifyBtn: false,
            showChangePhone: false,
            phoneError: "",
            okay: "",
            otp_agree: 0,
            otpAgreeError: false,
            loginPath: this.props.history.location.state == undefined ? null : this.props.history.location.state.loginPath,
            taskData: this.props.history.location.state == undefined ? null : this.props.history.location.state.taskData,
            booking_data: this.props.history.location.state == undefined ? null : this.props.history.location.state.booking_data,
            taskDataFromConfirmPage: this.props.history.location.state == undefined ? null : this.props.history.location.state.taskDataFromConfirmPage

        };
    }
    checkReferralCode = () => {
        console.log("rj email ", this.state.email)
        console.log("rj name ", this.state.name)
        this.signupActionCall();
    }
    componentDidMount = async () => {
        this.setState({
            playerId: window.onesignalId
        });
    };

    componentDidUpdate() {
        if (this.state.timer === 0) {
            clearInterval(this.time)
        }

    }
    componentWillUnmount() {
        clearInterval(this.time)
    }
    handleClose = () => {
        this.props.closeLoginPopup();
    };
    renderSignupButton = () => {
        if (this.state.loaderButton) {
            return <CircularProgress />;
        } else {
            return (
                <a
                    className="custom-button"
                    href="javascript:void(0)"
                    onClick={() => this.checkReferralCode()}

                >
                    {/* <FormattedMessage id="register" defaultMessage="Register" /> */}
                    SIGN UP
                </a>

            );
        }
    };


    signupActionCall = () => {
        // console.log("rj email ",this.state.email)
        // console.log("rj  ",this.state.name)
        // return
        if (this.state.email == "") {
            NotificationManager.error(
                "Email field required!",
                'Oops!'
            );
        } else if (this.state.name == "") {
            NotificationManager.error(
                "please enter name",
                'Oops!'
            );
        } else {

            /* if (
                validateSignUpData(
                    this.state.name,
                    null,
                    this.state.email,
                    this.state.password,
                    this.handleError
                )
            ) { */
            this.setState({ loaderButton: true });
            this.props.signupAction(
                {
                    name: this.state.name,
                    email: this.state.email,
                    otp: this.state.password,
                    phone: this.state.phone,
                    role: ROLE_CUSTOMER,
                    countryCode: this.state.countryCode,
                    playerId: window.onesignalId,
                    referral_code: this.state.reffer
                },
                this.onDone
            );
        } /* else {
            NotificationManager.error(
                <FormattedMessage
                    id="Validation Error"
                    defaultMessage="Validation Error"
                />,
                'Oops!'
            );
        } */
    };
    handleError = params => {
        this.setState(params);
    };

    onDone = (success, data) => {
        if (success) {
            cookies.set('x-auth-token', data.token, { path: '/' });
            /* var cookies = new Cookies(); */
            /* if (cookies.get('x-auth-token', { path: '/' })) {
                
            } */
            if (this.state.loginPath === "BookingConfirmPaymentSignIn" || this.state.loginPath === "BookingConfirmPaymentLogin" || this.state.loginPath === "BookingConfirm" || this.state.loginPath === "BookingConfirmAdressLogin" || this.state.loginPath === 'BookingConfirmAdressSignIn' || this.state.loginPath === 'BookingConfirmgback') {
                this.props.history.push('/user/booking_confirm', {
                    booking_data: this.state.booking_data,
                    loginPath: this.state.loginPath,
                    taskData: this.state.taskData,
                    taskDataFromConfirmPage: this.props.history.location.state.taskDataFromConfirmPage,
                    BookingPath: this.props.history.location.state.BookingPath,
                    taskDataFromConfirmPage: this.props.history.location.state.taskDataFromConfirmPage

                })
            }
            this.setState({
                loaderButton: false,
                dashboardRedirect: true
            });
            this.setState({
                loaderButton: false,
                isVerificationOpen: true
            });
        } else {
            this.setState({
                loaderButton: false,
                emailError: data
            });
        }
    };


    renderGetOtpButton = () => {
        if (this.state.loaderButton) {
            return <CircularProgress />;
        } else {
            return (
                <button
                    disabled={this.state.otpAgreeError ? true : false}
                    className="custom-button"
                    onClick={() => this.getOptCall()}
                >
                    GET ONE TIME PASSWORD
                    {/* <FormattedMessage id="login" defaultMessage="Login" /> */}
                </button>
            );
        }
    };

    renderVerifyOtpButton = () => {
        if (this.state.loaderButton) {
            return <CircularProgress />;
        } else {
            return (
                <button
                    className="custom-button"
                    onClick={() => this.getVerifyOptCall()}
                >
                    VERIFY ONE TIME PASSWORD
                    {/* <FormattedMessage id="login" defaultMessage="Login" /> */}
                </button>
            );
        }
    }

    getOptCall = () => {
        if (this.state.otp_agree === 0) {
            this.setState({ otpAgreeError: true })
        } else {
            this.setState({ otpAgreeError: false })
            if (this.state.phone.length != 10 & this.state.phone.length != 0) {
                this.setState({
                    phoneError: "Phone No length Should Be 10"
                })
            } else {
                this.setState({ loaderButton: true, timer: 90, showChangePhone: true });
                axios({
                    method: 'post',
                    url: `${SERVER_URL}/otp/generate`,
                    data: {
                        country_code: this.state.countryCode,
                        phone: this.state.phone,
                        role: ROLE_CUSTOMER
                    },
                }).then(resJson => {
                    // this.state.okay = resJson.data.status == "OK"
                    // console.log("Adahvs a s a sjhasca:::", resJson)
                    if (resJson.data.status == "OK") {
                        NotificationManager.success("Success", resJson.data.message)
                        this.time = setInterval(() => {
                            this.setState((prevState => ({
                                timer: prevState.timer - 1
                            })))
                        }, 1000)
                        this.setState({
                            loaderButton: false,
                            hideGetOtp: true,
                            hideExtraField: false,
                            showVerifyBtn: true,
                            password: ""
                        })
                    } else {
                        NotificationManager.error("Oops!", resJson.data.message)
                        this.setState({
                            loaderButton: false,
                            password: "",
                            showChangePhone: false,
                        })
                    }
                })
            }
        }
    }

    getVerifyOptCall = () => {
        this.setState({ loaderButton: true });
        axios({
            method: 'post',
            url: `${SERVER_URL}/otp/verify`,
            data: {
                country_code: this.state.countryCode,
                phone: this.state.phone,
                otp: this.state.password
            },
        }).then(resJson => {

            if (resJson.data.status == "OK") {
                NotificationManager.success("Success", resJson.data.message)

                this.setState({ okay: resJson.data.message })

                this.setState({
                    loaderButton: false,
                    hideLogin: false,
                    hideExtraField: false,
                    showVerifyBtn: false
                })
            } else {
                NotificationManager.error("Oops!", resJson.data.message)
                this.setState({
                    loaderButton: false
                })
            }
        })
    }

    handleOtpAgree = event => {
        this.setState({ otp_agree: event.target.value, otpAgreeError: false })
        //    this.setState({color: '#0078ff'});
    };

    render() {
        const {
            passwordError,
            emailError,
            nameError,
            refferError,
            countryCodeError,
            loaderButton,
            hideLogin,
            showChangePhone,
            phoneError

        } = this.state;
        const { formatMessage } = this.props.intl;
        if (this.state.redirect) {
            this.props.history.push({
                pathname: `/customer-verification`
            });
            // return <Redirect to={'/customer-verification'} />;
        }

        if (this.state.dashboardRedirect) {
            NotificationManager.success(
                <FormattedMessage id="Welcome" defaultMessage="Welcome" />,
                'Success'
            );
            this.props.history.push({ pathname: `/user/dashboard` });
            // this.props.history.push({ pathname: `/` });
        }
        return (
            <div>

                <form className="form-new" autoComplete="false">

                    <div className="dialog-body">

                        <div className="row">
                            <div className="col-md-4">
                                <FormControl
                                    className={
                                        'login-form-textfield phone-field'
                                    }
                                    error={countryCodeError ? true : false}
                                >
                                    <InputLabel shrink>
                                        <FormattedMessage
                                            id="countryCode"
                                            defaultMessage="Country Code"
                                        />
                                    </InputLabel>
                                    {/* <Select
                                        className="login-form-textfield form-control"
                                        autoWidth={true}
                                        value={this.state.countryCode}
                                        onChange={this.handleCountryChange}
                                        inputProps={{
                                            name: 'countryCode'
                                        }}
                                    >
                                        {countries.map((country, index) => {
                                            return (
                                                <MenuItem
                                                    value={country.code}
                                                    key={index}
                                                >
                                                    {country.code}
                                                </MenuItem>
                                            );
                                        })}
                                    </Select>
                                    <FormHelperText>
                                        {countryCodeError}
                                    </FormHelperText> */}
                                </FormControl>
                            </div>
                            <div className="col-md-12 mb-2">
                                <TextField
                                    error={phoneError ? true : false}
                                    helperText={phoneError}
                                    className="login-form-textfield"
                                    label={formatMessage({
                                        id: 'phone'
                                    })}
                                    id="phone"
                                    fullWidth={true}
                                    name="phone"
                                    type="number"
                                    placeholder="Enter Mobile"
                                    value={this.state.phone}
                                    onChange={e => {
                                        const re = /^[0-9\b]+$/;
                                        if (e.target.value === '' || re.test(e.target.value) && e.target.value.length <= 10) {
                                            this.setState({
                                                phone: e.target.value,
                                                phoneError: "",
                                                error: ""
                                            })
                                        }
                                    }}
                                    disabled={this.state.loaderButton || this.state.showVerifyBtn || !this.state.hideExtraField}

                                    margin="normal"
                                />

                                {this.state.showChangePhone && (
                                    <a className="mb-2" style={{ justifyContent: "flex-end", display: "flex" }} href="javascript:void(0);">
                                        <p style={{
                                            fontWeight: "normal",
                                            ":hover": {
                                                fontWeight: "bold",
                                            }
                                        }}
                                            onClick={() => {
                                                this.setState({
                                                    hideGetOtp: false,
                                                    hideLogin: true,
                                                    hideExtraField: true,
                                                    showVerifyBtn: false,
                                                    showChangePhone: false,
                                                    timer: 0
                                                })
                                            }}>
                                            Change Phone
                                        </p>
                                    </a>
                                )}
                            </div>

                        </div>
                        {
                            this.state.otpAgreeError
                                ? <p style={{ color: 'red', fontSize: 17, marginLeft: 47, marginTop: 10 }}>Please agree to recieve text messages from ezPro</p>
                                : null
                        }
                        {this.state.hideGetOtp &&
                            <div className="input-field s12" style={{ marginTop: -20, display: "flex", flexDirection: "column" }}>
                                <TextField
                                    error={passwordError ? true : false}
                                    helperText={passwordError}
                                    className="login-form-textfield"
                                    label={"One Time Password"}
                                    id="password"
                                    type="number"
                                    fullWidth={true}
                                    name="OTP"
                                    placeholder="Enter One Time Password"
                                    value={this.state.password}
                                    onChange={event => {
                                        const re = /^[0-9\b]+$/;
                                        if (event.target.value === '' || re.test(event.target.value) && event.target.value.length <= 8) {
                                            this.setState({
                                                password: event.target.value,
                                                passwordError: '',
                                                error: ""
                                            });
                                        }
                                    }}
                                    disabled={this.state.loaderButton}
                                    margin="normal"
                                />

                                {this.state.okay ? null :
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "end"
                                        }}
                                        className="input-field s12">
                                        {!this.state.timer == 0 ? <a href="javascript:void(0);">
                                            <p >
                                                Resend One Time Password in&nbsp;
                                                <span style={{
                                                    fontWeight: "bold",
                                                    color: "#0078ff"
                                                }}>
                                                    0:{this.state.timer}
                                                </span>
                                            </p>
                                        </a> : <a href="javascript:void(0);">
                                            <p onClick={() => {
                                                this.getOptCall()
                                            }}>
                                                Resend One Time Password
                                            </p>
                                        </a>}
                                    </div>}



                            </div>
                        }
                        {!this.state.hideExtraField && !this.state.showVerifyBtn &&
                            <TextField
                                error={nameError ? true : false}
                                helperText={nameError}
                                className="login-form-textfield"
                                label={formatMessage({
                                    id: 'name'
                                })}
                                id="name"
                                fullWidth={true}
                                name="name"
                                type="text"
                                placeholder="Enter Name"
                                value={this.state.name}
                                onChange={event => {
                                    this.setState({
                                        name: event.target.value,
                                        nameError: ''
                                    });
                                }}
                                disabled={loaderButton}
                                margin="normal"
                            />}

                        {
                            !this.state.hideExtraField && !this.state.showVerifyBtn &&
                            <TextField
                                error={emailError ? true : false}
                                helperText={emailError}
                                className="login-form-textfield"
                                label={formatMessage({
                                    id: 'email'
                                })}
                                id="email"
                                fullWidth={true}
                                name="email"
                                type="email"
                                placeholder="Enter Email"
                                value={this.state.email}
                                onChange={event => {
                                    this.setState({
                                        email: event.target.value,
                                        emailError: ''
                                    });
                                }}
                                disabled={loaderButton}
                                margin="normal"
                            />
                        }
                        {
                            !this.state.hideExtraField && !this.state.showVerifyBtn &&
                            <TextField
                                error={refferError ? true : false}
                                helperText={refferError}
                                className="login-form-textfield"
                                label={formatMessage({
                                    id: 'enterReffer'
                                })}
                                id="reffercode"
                                fullWidth={true}
                                name="Reffer Code"
                                type="text"
                                placeholder="Enter Reffer Code"
                                value={this.state.reffer}
                                onChange={event => {
                                    this.setState({
                                        reffer: event.target.value,
                                        refferError: ''
                                    });
                                }}
                                disabled={loaderButton}
                                margin="normal"
                            />
                        }
                        <div

                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                marginTop: '10px'
                                // marginTop: 45
                                // justifyContent: 'center',
                            }}>
                            <Radio
                                className="checked-radio"
                                checked={
                                    this.state.otp_agree == 1
                                }
                                onChange={event => this.handleOtpAgree(event)}
                                // onChange={this.handlePaymentOption}
                                value="1"
                                color="primary"
                                style={{}}
                            /><p

                                style={{
                                    fontSize: 15
                                }}>I agree to receive text messages from eZpro (+1 8882903499)</p>
                        </div>
                        {!this.state.hideGetOtp &&
                            <div className="d-flex justify-content-center md-12">
                                {this.renderGetOtpButton()}
                            </div>}

                        {this.state.showVerifyBtn &&
                            <div className="d-flex justify-content-center md-12 mt-3">
                                {this.renderVerifyOtpButton()}
                            </div>}

                    </div>
                    {
                        !hideLogin && <div className="d-flex justify-content-center md-12">

                            {this.renderSignupButton()}

                        </div>}


                </form>
                {/* <CustomerVerification
                    email={this.state.email}
                    open={this.state.isVerificationOpen}
                    close={this.closeVerification}
                /> */}
            </div>
        );
    }
}
const mapStateToProps = ({ settings }) => {
    return {
        colors: settings.colors
    };
};
const composedComponent = compose(
    withTheme(),
    connect(
        mapStateToProps,
        actions
    )
);
export default composedComponent(injectIntl(withRouter(CustomerSignup)));



// WEBPACK FOOTER //
// ./src/components/Customer/CustomerSignup.jsx